const comments = [
  {
    id: 1,
    name: '影迷小李',
    avatar: 'L',
    rating: 5,
    time: '2小时前',
    movie: '《星际征途：新纪元》',
    text: '画面真的绝了！每一帧都能当壁纸，剧情节奏也很紧凑，两个半小时完全没觉得长。陌陌的4K画质太香了，强烈推荐用大屏看！',
  },
  {
    id: 2,
    name: '电影控阿明',
    avatar: 'A',
    rating: 5,
    time: '昨天 21:30',
    movie: '《时光旅人》',
    text: '很久没看到这么走心的国产剧情片了。演员演技在线，叙事手法也很巧妙。在陌陌影视上二刷了，依然感动得不行。',
  },
  {
    id: 3,
    name: '周末观影人',
    avatar: 'Z',
    rating: 4,
    time: '3天前',
    movie: '《暗夜追踪》',
    text: '反转反转再反转！看完结局直接起鸡皮疙瘩。陌陌的片源更新速度真的快，刚上映就有了高清版，点赞！',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={`text-xs ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-secondary-300'}`}></i>
      ))}
    </div>
  );
}

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-chat-3-line mr-1"></i>真实反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">观众热评</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">看看影迷朋友们都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((c) => (
            <div key={c.id} className="bg-background-100 rounded-xl p-5 border border-secondary-200/50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold text-sm flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <StarRating rating={c.rating} />
              <p className="text-xs text-primary-600 font-medium mt-2 mb-2">{c.movie}</p>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}